module.exports = __webpack_public_path__ + "img/footer-contact-icon-row-dark-lincoln.c143a711.png";